import { CertificateModalInitialState } from './reducers';

export const getCertificateState = ({ pages: { certificates } }) =>
  certificates as CertificateModalInitialState;

